import axios from 'axios';
import moment from 'moment';
import { APIResponse, AuthLoginResponse, BankAccount, BankAccountForm, LoginSource, Schedule, TokenData, UserSession } from './Classes';

const DEBUG = process.env.REACT_APP_DEBUG === '1';
const API_ROOT = process.env.REACT_APP_API_URL;
const AUTH_ROOT = process.env.REACT_APP_AUTH_URL;
export const CDN_URL = process.env.REACT_APP_CDN_URL;


var getToken =(): TokenData=>{
	var jsonstr = localStorage.getItem('team_hr_access_token');
	if(!jsonstr) return null;

	try{
		var data = JSON.parse(jsonstr) as TokenData;
		if(!data?.access) return null;
		if(data.expires <= (moment().unix() + 30)) return null;
		return data;
	}catch{
		return null;
	}
}

var saveToken =(token_data: TokenData)=>{
	localStorage.setItem('team_hr_access_token', JSON.stringify(token_data));
}

var getUser =(): UserSession=>{
	try{
		return JSON.parse(localStorage.getItem('team_hr_user_data')) as UserSession;
	}catch{
		return null;
	}
}

var logout =()=>{
	localStorage.removeItem('team_hr_access_token');
	localStorage.removeItem('team_hr_user_data');
	window.dispatchEvent(new Event('team_hr_user_data'));
	window.dispatchEvent(new Event('team_hr_user_logout'));
}

async function post<T = any>(endpoint: string, data?: any, opts: { login?: boolean; accessToken?: string } = {}): Promise<APIResponse<T>>{
	var headers: Record<string, string>={
		'Content-Type': 'application/json',
		'show-code': DEBUG ? '1' : '0',
	};

	if(opts.login !== false){
		var token = opts.accessToken ?? getToken()?.access ?? '';
		if(token) headers.token = token;
	}

	try{
		var res = await axios.post(`${API_ROOT}/${endpoint.replace(/^\/+/, '')}`, data, { headers });
		if(res.data?.error && (res.data.code === 'P-TKNE' || res.data.code === 'P-TKNV')) logout();
		return res.data as APIResponse<T>;
	}catch(err){
		if((err as any)?.code === 'ERR_NETWORK') return { error: true, code: 'API-NONTWK', message: 'No se pudo establecer una conexión con el servidor.' };
		return { error: true, code: 'API-LCL-1', message: 'Hubo un error inesperado.' };
	}
}

var getLogin = async (force: boolean = false, access_token: string = null, dispatch_event: boolean = true)=>{
	var token = access_token || getToken()?.access;
	if(!token) return { error: true, code: 'NOTKN', message: 'No hay token de acceso' } as APIResponse;

	var res = await post<UserSession>('users/me', {}, { accessToken: token });
	if(res.error) return res;
	localStorage.setItem('team_hr_user_data', JSON.stringify(res.data));
	setTimeout(()=>{
		if(dispatch_event) window.dispatchEvent(new Event('team_hr_user_data'));
	}, 50);
	return res;
}

var onLoginToken = async (token: string, dispatch_event: boolean = true)=>{
	var res = await post<AuthLoginResponse>('auth/login', { token, source: LoginSource.HR }, { login: false });
	if(!res.error && res.data){
		saveToken(res.data.token);
		if(dispatch_event) window.dispatchEvent(new Event('team_hr_user_token'));
		getLogin(true, res.data.token.access, true);
	}
	return res;
}

var getLoginUrl =()=>{
	var continueUrl = `${window.location.origin}/auth`;
	return `${AUTH_ROOT}?${new URLSearchParams({ s: `${LoginSource.HR}`, continue: continueUrl, sv: DEBUG ? '1' : '0' })}`;
}

var getCheckinToday =()=> post<Schedule>('hr/schedule/get', {});

var checkIn =(schedule_id: number, date: number, start_lattitude: number, start_longitude: number)=>
	post<{ log_id: number; arrival_status: number; late_seconds: number }>('hr/checkin', { schedule_id, date, start_lattitude, start_longitude });

var checkOut =(log_id: number, date: number, end_lattitude: number, end_longitude: number)=>
	post('hr/checkout', { log_id, date, end_lattitude, end_longitude });

var listBankAccounts =()=> post<BankAccount[]>('users/banks/list', {});

var addBankAccount =(form: BankAccountForm)=> post<BankAccount>('users/banks/add', form);

var setPrimaryBankAccount =(account_id: number)=> post('users/banks/primary', { account_id });

var deleteBankAccount =(account_id: number)=> post('users/banks/delete', { account_id });

export default {
	getToken,
	getUser,
	getLogin,
	onLoginToken,
	logout,
	getLoginUrl,
	getCheckinToday,
	checkIn,
	checkOut,
	listBankAccounts,
	addBankAccount,
	setPrimaryBankAccount,
	deleteBankAccount,
};
